module.exports = __webpack_public_path__ + "img/drop.da9e0e13.svg";